module.exports = __webpack_public_path__ + "img/pdf_bg.0c177564.png";